import {debounce} from 'throttle-debounce';
import Global from './global';

const $ = jQuery.noConflict();

'use strict';
const Search = {
    /*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/
    $domSearchInput: $('.js-search-suggestions-input'),
    $domSearchInputHolder: $('.js-search-suggestions-input-holder'),
    $domSearchSuggestions: $('.js-search-suggestions'),
    $domResultsNum: $('.js-header-search__results-number'),
    $domBtnResults: $('.js-header-search-btn__results-number'),
    $domBtn: $('.header-search__results--btn'),
    $domAllResultsBtn: $('.js-header-search__results--btn'),
    $domAllResultsBtnHolder: $('.js-header-search__results--btn-holder'),
    $searchForm: $('.js-site-header__search-wrapper'),
    $domSearchTrigger: $('.js-search-trigger'),
    $domSearchClose: $('.js-search-suggestions__close'),
    $domHeader: $('.js-site-header'),
    $domSearchHolder: $('.js-header-search'),
    $domSearchBottom: $('.js-header-search__bottom'),
    $domSearchLoader: $('.js-search-loader'),
    $domSearcicon: $('.js-site-header__search-icon'),

    $domChat: $('#tidio-chat-iframe'),

    classSrcOpened: 'search-is-opened',
    classOpened: 'opened',
    classLoading: 'loading',
    classHide: 'hide',

    searchRequest: null,

    /**
     * AJAX call for retrieving the search suggestions
     *
     * @param val
     * @param context
     */
    /*getSuggestions: (val, context) => {
        Search.searchRequest = $.ajax({
            url: kadraGlobal.ajax,
            dataType: 'json',
            data: {
                action: 'searchSuggestions',
                search: val
            },
            success: function (response) {
                Search.fillSuggestions(response.data, context);
                Search.$domSearchInputHolder.removeClass(Search.classLoading);
                Search.$domSearchBottom.addClass(Search.classOpened);
                Search.$domSearchBottom.removeClass(Search.classLoading);
                const catWrapper = document.querySelector('.js-header-search__wrapper-categories-wrapper');
                catWrapper.innerHTML = '';
                // eslint-disable-next-line no-unused-vars
                const categories = response.data.categories;
                Search.$domSearchLoader.removeClass('search-loader--active');
                Search.$domSearcicon.css('display', 'block');
                for (let i = 0; i < response.data.brands.length; i++) {
                    // eslint-disable-next-line prefer-const
                    let brand = response.data.brands[i];
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('header-search__wrapper-categories-item-wrapper');

                    const link = document.createElement('a');
                    link.classList.add('header-search__wrapper-categories-item');
                    link.setAttribute('href', brand.url);
                    const span = document.createElement('span');
                    span.classList.add('header-search__wrapper-categories-item-name');
                    span.innerHTML = brand.name;
                    link.appendChild(wrapper);
                    wrapper.appendChild(span);
                    catWrapper.appendChild(link);
                }
                const brandsTitle = document.querySelector('.js-header-search__wrapper-categories-title');
                if(response.data.brands.length < 1) {
                    brandsTitle.style.display = 'none';
                }else {
                    brandsTitle.style.display = 'block';
                }

                if (window.innerWidth < 992) {
                    $('#tidio-chat-iframe').hide();
                    Search.$domSearcicon.css('display', 'none');
                }
            }
        });
    },*/

    /**
     * Method which parses array data and fills the suggestions
     *
     * @param data
     * @param context
     */
    fillSuggestions: (data) => {
        if (data.number === 'Total 0 Results') {
            $('.js-search-results-wrap').addClass('hidden');
            $('.js-header-search__bottom').addClass('empty');
        } else {
            $('.js-search-results-wrap').removeClass('hidden');
            $('.js-header-search__bottom').removeClass('empty');
        }
        Search.$domSearchSuggestions.html(data.html);
        Search.$domResultsNum.html(data.number);
        Search.$domBtnResults.html(data.numberBtn);
        Search.$domBtn.removeClass(Search.classHide).addClass(data.showAllResultsBtn);
        $('.js-header-search__results-no-results').removeClass(Search.classHide).addClass(data.showResults);
        Search.$domAllResultsBtn.attr('href', data.allResults);
        Search.$domAllResultsBtnHolder.removeClass(Search.classHide).addClass(data.showAllResultsBtn);
    },

    /*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {
        /**
         * On search input keyup debounce the ajax call
         */
        /*this.$domSearchInput.bind('change keyup input', debounce(200, (e) => {

            const _self = e.currentTarget;
            const val = $(_self).val();

            Search.$domSearcicon.css('display', 'none');
            Search.$domSearchLoader.addClass('search-loader--active');
            // Abort previous requests
            if (Search.searchRequest) {
                Search.searchRequest.abort();
            }

            if (val.length >= 2) {
                Search.getSuggestions(val, _self);
                Search.$domSearchInputHolder.addClass(Search.classLoading);
                Search.$domSearchBottom.addClass(Search.classLoading);
                Search.$domSearchHolder.addClass(Search.classOpened);
                Global.$domBody.addClass(Search.classSrcOpened);
            } else {
                Search.fillSuggestions('');
                Search.$domSearchBottom.removeClass('opened loading');
                Global.$domBody.removeClass(Search.classSrcOpened);
                Search.$domSearchLoader.removeClass('search-loader--active');
                Search.$domSearcicon.css('display', 'block');
            }

            if (window.innerWidth < 992) {
                Search.$domSearcicon.css('display', 'none');
            }
        }))
            // If ENTER pressed, close the suggestions and trigger filtration
            .on('keyup', (e) => {
                if (e.keyCode === 13 && this.$domSearchInput.val().length >= 2) {
                    this.$searchForm.trigger('submit');
                }
            })
            // On focusout, do the filtration if string is changed
            .on('focusout', () => {
                // const newVal = $(e.currentTarget).val();
            });
        */

        /**
         * @description Open search
         */
        Search.openSearch();

        /**
         * @description close search
         */
        function closeSrc()
        {
            Search.$domHeader.removeClass(Search.classSrcOpened);
            Search.$domSearchHolder.removeClass(Search.classOpened);
            Global.$domBody.removeClass(Search.classSrcOpened);
            Search.$domSearchInput.val('').trigger('keyup');
            $('#tidio-chat-iframe').show();
        }

        /**
         * @description Close Search
         */
        Search.closeSearch();

        // Search.close();
        Global.functions.clickOutsideContainer($('body'), $('.js-header-search, .js-site-header__search-wrapper'), $('.js-search-suggestions__close'), closeSrc);
        Global.functions.escKey(closeSrc);
    },

    /**
     * @description Open search
     */
    openSearch: () => {
        Search.$domSearchTrigger.on('click', () => {

            Search.$domHeader.toggleClass(Search.classSrcOpened);
            Search.$domSearchHolder.toggleClass(Search.classOpened);
            Global.$domBody.toggleClass(Search.classSrcOpened);

        });
    },

    /**
     * @description Close Search
     */
    closeSearch: () => {
        Search.$domSearchClose.on('click', () => {

            Search.$domHeader.removeClass(Search.classSrcOpened);
            Search.$domSearchHolder.removeClass(Search.classOpened);
            Global.$domBody.removeClass(Search.classSrcOpened);
            Search.$domSearchInput.val('');
            $('#tidio-chat-iframe').show();
        });
    },
};

export default Search;
